// extracted by mini-css-extract-plugin
export default {"icon":"AsyncTypeahead_icon__jXjgi","image":"AsyncTypeahead_image__x-bFa","left":"AsyncTypeahead_left__2eSgs","right":"AsyncTypeahead_right__ClLr3"};